import { PlanoSaudeProcedimentoPk } from "./pks/plano-saude-procedimento-pk";

export class PlanoSaudeProcedimento {

    pk: PlanoSaudeProcedimentoPk = new PlanoSaudeProcedimentoPk;

    constructor() {
    }
}
